import React from 'react'
import { Icon } from 'antd'
import { fromEmpty } from '../utils'
import { Just } from 'data.maybe'
import ReactJson from 'react-json-view'
import styled from 'styled-components'

const ValidationContent = styled.ul`
  margin: 0;
`

const DetailedHeader = styled.div`
  cursor: pointer;
`

class DetailedValidation extends React.Component {
  state = { expand: false }
  toggleExpand = _ => this.setState(({ expand }) => ({ expand: !expand }))

  render() {
    const { expand } = this.state
    const { msg, data, errorRenderer } = this.props
    return (
      <div data-testid="error-panel">
        <DetailedHeader onClick={this.toggleExpand}>
          <Icon type={!expand ? 'caret-down' : 'caret-right'} theme="filled" />
          {msg}
        </DetailedHeader>
        {expand && (
          <ValidationContent>
            {data.map((item, i) => (
              <li key={i}>
                {errorRenderer ? errorRenderer(item) : <ReactJson src={item} />}
              </li>
            ))}
          </ValidationContent>
        )}
      </div>
    )
  }
}

//

const ValidationError = ({ validationError, errorRenderer }) => (
  <div>
    {validationError.map((e, i) =>
      fromEmpty(e.data)
        .map(_ => (
          <DetailedValidation
            errorRenderer={errorRenderer}
            {...e}
            index={i}
            key={i}
          />
        ))
        .orElse(_ => Just(<div>{e.msg}</div>))
        .get()
    )}
  </div>
)

//
export default ValidationError
